if (window.location.href.includes("inyeccion/periodo" ) || window.location.href.includes("soplado/periodo")) {
    
    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };
    const btnActivar = document.querySelector("#contPersonalReporte article[data-modal='modalAgregarColaborador']");
    const tableBody = document.querySelector("#modalAgregarColaborador .contColaboradores");
    const inputFiltroNombre = document.getElementById("filtroNombre");
    const inputFiltroArea = document.getElementById("filtroArea");
    let timeoutFiltro = null;
    const v = Date.now();

    const actualizarTabla = () => {

        const filtroNombre = inputFiltroNombre.value;
        const filtroArea = inputFiltroArea.value || btnActivar.getAttribute("data-area") || '';

        const url = `/api/personal?filtroNombre=${filtroNombre}&filtroArea=${filtroArea}`;
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                tableBody.innerHTML = "";
                const data = result.result;

                data.resultado.forEach(item => {
                    const row = document.createElement("div");
                    row.innerHTML = `
                    <div class="colaborador" data-id="${item.idUsuario}" data-nombre="${item.nombreCompletoUsuario}" data-area="${item.nombreArea}" data-cargo="${item.nombreCargo}">
                        <img class="imgColaborador" src="/public/uploads/usuarios/${item.fotoUsuario}?v=${v}" alt="colaborador">
                        <article class="articuloCard" >
                            <div class="articuloCardTitulo">
                                <h3>${item.nombreCargo}</h3>
                            </div>
                            <dl class="articuloCardLista">
                                <dt>Nombre:</dt>
                                <dd>${item.nombreCompletoUsuario}</dd>
                                <dt>Area:</dt>
                                <dd class="ddArea">${item.nombreArea}</dd>
                            </dl>
                        </article>
                    </div>
                    `;
                    tableBody.appendChild(row);
                });

                if (data.num_registros == 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data"); //Asignar la clase al <tr>
                    row.innerHTML = `
                        <tr class="no-data">
                            <td colspan="5">
                                <div class="cont-no-data">
                                    No se encontró información.
                                    <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                                </div>
                            </td>
                        </tr>
                    `;
                    tableBody.appendChild(row);
                }
            })
            .catch((error) => {
                if (err.name === 'AbortError') return;
                console.error("Error al seleccionar personal:", err);
                return;
            });
    };

    const actualizarConDebounce = () => {
        clearTimeout(timeoutFiltro);

        timeoutFiltro = setTimeout(() => {
            actualizarTabla();
        }, 300);
    };

    btnActivar.addEventListener("click", actualizarTabla());
    inputFiltroNombre.addEventListener("input", actualizarConDebounce);
    inputFiltroArea.addEventListener("input", actualizarConDebounce);

}
